import { useCookie } from "#imports";
import { defineStore } from "pinia";
import { ref } from "vue";
export const useUserStore = defineStore("userStore", () => {
  const currentUserId = ref(null);
  const currentUser = ref(null);
  const users = ref({ paginatorInfo: { count: 0 }, data: [] });
  const user = ref(null);
  const refreshToken = useCookie("auth-refresh-token");
  const accessToken = useCookie("auth-access-token");
  function setUsers(usersData) {
    users.value = usersData;
  }
  function setUser(userData) {
    user.value = userData;
  }
  function logout() {
    refreshToken.value = null;
    accessToken.value = null;
    currentUser.value = null;
  }
  return {
    currentUserId,
    currentUser,
    users,
    user,
    setUsers,
    setUser,
    logout
  };
});
